import { useState } from 'react';

import type { OrganizationPreferenceResponseBody } from '@rtkwlf/notification-service';
import { useTranslation } from 'react-i18next';

import {
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from '@packages/fenrir/components';

interface NotificationFrequencyGroupProps {
  preferences?: OrganizationPreferenceResponseBody;
  onDigestModeChange?: (isDigest: boolean) => void;
  isUpdating?: boolean;
}

const NotificationFrequencyGroup = ({
  preferences,
  onDigestModeChange,
}: NotificationFrequencyGroupProps) => {
  const { t } = useTranslation('notifications');
  const [selectedValue, setSelectedValue] = useState(
    preferences?.isDigestEnabled ? 'daily' : 'off',
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDigestFrequency = event.target.value;
    setSelectedValue(newDigestFrequency);

    if (onDigestModeChange) {
      onDigestModeChange(newDigestFrequency === 'daily');
    }
  };

  return (
    <FormGroup sx={{ mb: 4 }}>
      <FormLabel>{t('digestMode')}</FormLabel>
      <RadioGroup value={selectedValue} onChange={handleChange}>
        <FormControlLabel
          value="daily"
          control={<Radio sx={{ py: '.125rem' }} />}
          label={t('digestModes.daily')}
          sx={{ py: '.125rem' }}
        />
        <FormControlLabel
          value="off"
          control={<Radio sx={{ py: '.125rem' }} />}
          label={t('digestModes.off')}
          sx={{ py: '.125rem' }}
        />
      </RadioGroup>
    </FormGroup>
  );
};

export default NotificationFrequencyGroup;
